import React from 'react';

import { Text, TEXT_VARIANTS } from 'ui/Typography';

class QuestionField extends React.Component {
  constructor(props) {
    super(props);
    this.state = { userInput: props.userInput };
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.saveQuestionFieldAnswer = this.saveQuestionFieldAnswer.bind(this);
  }

  /*
   * Formats the question field's data in prep for the backend -
   * We need an object with the question field's title as the key
   * and the user's input as the value
   */
  saveQuestionFieldAnswer(input) {
    const dataToSend = {};
    dataToSend[String(this.props.title)] = input;
    this.props.updateQuestionFieldData(dataToSend);
  }

  handleTitleChange(e) {
    this.setState({ userInput: e.target.value });
    this.saveQuestionFieldAnswer(e.target.value);
  }

  render() {
    const { title, isDisabled, previewing } = this.props;

    return (
      <div className="QuestionField">
        <div className="mb-16 mt-16">
          <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>{title}</Text>
        </div>
        <input
          className="ReplyContainer-input bg-gray-lightest bdrs-2 border border-gray-light mh-40 p-8 pl-12"
          value={previewing ? '' : this.state.userInput}
          onChange={this.handleTitleChange}
          disabled={isDisabled}
        />
      </div>
    );
  }
}

export default QuestionField;
